import { FETCH_VENDORS_SUCCESS, FETCHING_VENDORS } from './VendorsConstants';

const initialState = {
  fetchingVendors: false,
  vendors: [],
};

const VendorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_VENDORS:
      return { ...state, fetchingVendors: true };
    case FETCH_VENDORS_SUCCESS:
      return { ...state, fetchingVendors: false, vendors: action.vendors };
    default:
      return state;
  }
};

export default VendorsReducer;



// WEBPACK FOOTER //
// ./src/redux/vendors/VendorsReducer.js